import React from 'react';
import { connect } from 'react-redux';
import DatasetConditionDialog from './DatasetConditionDialog';
import DatasetConditionDeletionDialog from './DatasetConditionDeletionDialog';
import DatasetConditionsDialog from './DatasetConditionsDialog';

const DatasetConditionDialogs = ({
  allowDelete,
  allowEdit,
  allowView,
  theme,
}) => (
  <>
    {allowDelete && (<DatasetConditionDeletionDialog theme={theme} />)}
    {allowEdit && (<DatasetConditionDialog theme={theme} />)}
    {allowView && (<DatasetConditionsDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { update, read } } } },
  datasetConditions: { activeCondition, activeConditions, datasetConditions: { deletion } },
}) => ({
  allowDelete: deletion.open && update,
  allowEdit: activeCondition.open && update,
  allowView: activeConditions.open && read,
});

export default connect(mapStateToProps)(DatasetConditionDialogs);
